module.exports = __webpack_public_path__ + "img/c.2c671ec7.jpg";